// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyCYzFo6W4UbCUEnSkYBR_VXNfjsldx7zEw",
  authDomain: "utility-span-348417.firebaseapp.com",
  projectId: "utility-span-348417",
  storageBucket: "utility-span-348417.appspot.com",
  messagingSenderId: "38762194682",
  appId: "1:38762194682:web:d64f139514236adbe48b43",
  measurementId: "G-8JVCEZ2437",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

// Create a root reference
export const storage = getStorage();
